import { computed, inject, Signal } from '@angular/core';
import { GrowthBookService } from '@lentau/core/growth-book/shared';

export const OpenTelemetryExp: string = 'open_telemetry';

export const IsEnableOpenTelemetry: () => Signal<boolean> = (): Signal<boolean> => {
  const growthBookService: GrowthBookService = inject(GrowthBookService);
  return computed(() => growthBookService.checkFeature(OpenTelemetryExp, true));
};
